import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconGearGuidem = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={36}
    fill="none"
    viewBox="0 0 42 36"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-gear-guidem_svg__a)">
      <path
        fill="#fff"
        fillOpacity={0.95}
        d="M33.5 12.367c0 .274-.117.547-.313.781l-1.914 2.422c-.273.274-.625.43-.976.43-.274 0-.586-.078-.781-.234l-2.266-1.797v10.156c0 1.055-.86 1.875-1.875 1.875h-8.75a1.851 1.851 0 0 1-1.875-1.875V13.969l-2.305 1.797c-.195.156-.508.234-.78.234-.352 0-.704-.156-.977-.469l-1.915-2.383a1.194 1.194 0 0 1-.273-.78c0-.352.156-.704.469-.938l5.273-4.18a2.73 2.73 0 0 1 1.719-.625h1.328A3.741 3.741 0 0 0 21 9.75c1.836 0 3.36-1.328 3.672-3.125h1.289c.664 0 1.289.234 1.758.625l5.273 4.18c.313.234.508.586.508.937Z"
      />
    </g>
    <defs>
      <filter
        id="icon-gear-guidem_svg__a"
        width={41}
        height={36}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_24042"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_24042"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_24042"
          result="effect2_dropShadow_9632_24042"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_24042"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconGearGuidem;
